<template>
  <div v-if="dataReady && reportDataReady">
    <v-container v-if="!emergencyActive">
      <v-layout row v-if="!emergencyTriggered">
        <v-flex xs12>
          <v-btn block color="warning" @click="startEmergency">
            {{emergencyText}}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout row v-else>
        <v-flex xs8>
          <v-btn block color="warning" @click="startEmergency">
            {{emergencyText}}
          </v-btn>
        </v-flex>
        <v-flex>
          <v-btn xs4 block color="success" @click="cancelEmergency">No, Cancel</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container v-else grid-list-xl pb-5>
      <v-layout row>
        <v-flex xs6>
          <v-dialog v-model="closeEmergencyDialog" width="500">
            <v-btn slot="activator" round @click="closeEmergencyDialog = true">close emergency</v-btn>
            <v-card>
              <v-container>
                <v-card-title class="headline" primary-title>
                  Are you sure you want to close the emergency?
                </v-card-title>
                <v-layout row>
                  <v-btn @click="closeEmergency" color="warning">Close</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn @click="closeEmergencyDialog = false">Cancel</v-btn>
                </v-layout>
              </v-container>
            </v-card>
          </v-dialog>
        </v-flex>
        <v-flex xs6 class="text-xs-right">
          <v-dialog v-model="filterDialog" width="500">
            <v-btn round slot="activator" color="red lighten-2" dark>
              Filter
            </v-btn>
  
            <v-card>
              <v-card-title class="headline grey lighten-2" primary-title>
                Filter list
              </v-card-title>
              <v-container>
                <v-layout column>
                  <v-flex>
                    <v-switch :label="`Hide with no activity today: ${filter.noActivity.toString()}`" v-model="filter.noActivity"></v-switch>
                  </v-flex>
                  <v-flex>
                    <v-switch :label="`Hide people you have seen: ${filter.visuallySeen.toString()}`" v-model="filter.visuallySeen"></v-switch>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-divider></v-divider>
  
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="filterDialog = false">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 md6 lg4 v-for="(person, key) in dataTable" :key="key">
          <person-card v-if="emergencyActive" :person="person" :eventStartTime="emergencyReports[0].startTime" :seen="emergencyReports[0].userVisuallySeenKey.length === 0 ? false : hasUserBeenChecked(person)" @click.native="updateSeenStatus(person, key)" />
        </v-flex>
      </v-layout>
    </v-container>
    <v-bottom-nav
      v-if="emergencyActive"
      :value="true"
      fixed
      color="white"
    >
      <v-btn
        color="black"
        flat
        value="recent"
        
      >
        <span>Total Staff {{totalStaffActiveToday}}</span>
        <v-icon>people</v-icon>
      </v-btn>

      <v-btn
        color="black"
        flat
        value="favorites"
        
      >
        <span>Staff onsite {{totalStaffStillOnsite}}</span>
        <v-icon>warning</v-icon>
      </v-btn>

      <v-btn
        color="black"
        flat
        value="nearby"
        
      >
        <span>Staff seen {{totalStaffSeen}}</span>
        <v-icon>done</v-icon>
      </v-btn>
    </v-bottom-nav>
  </div>
</template>

<script>
  import moment from 'moment'
  import firebase from 'firebase'
  import {
    db
  } from '@/main.js'
  import PersonCard from '@/components/PersonCard'
  
  export default {
    components: {
      PersonCard
    },
    data() {
      return {
        name: '',
        dataReady: false,
        reportDataReady: false,
        newEventCreated: false,
        emergencyTriggered: false,
        emergencyActive: false,
        emergencyText: 'Start emergency',
        filterDialog: false,
        filter: {
          noActivity: true,
          visuallySeen: false
        },
        search: '',
        closeEmergencyDialog: false,
        // Firebase
        emergencyReports: [],
        users: [],
        userVisuallySeenKey: [],
        bottomNav: 'recent'
      }
    },
    methods: {
      chipColor(status) {
        let color = 'grey'
        switch (status) {
          case 'Offsite':
            color = 'green'
            break
          case 'Onsite G2':
            color = 'yellow'
            break
          case 'Onsite G3':
            color = 'blue'
            break
        }
        return color
      },
      chooseDateFilter(status) {
        if (status === 'No activity') {
          return this.moment
        } else {
          return this.momentDay
        }
      },
      myLoop() {
        let i = this.i
        setTimeout(function() {
  
          console.log(i)
          i--
          if (i > 0) {
            myLoop()
          }
        }, 1000)
      },
      startEmergency() {
        if (this.emergencyTriggered) {
          // this.emergencyActive = true
          this.initFirebaseReport()
        }
        this.emergencyText = 'Are you sure?, Yes'
        this.emergencyTriggered = true
      },
      cancelEmergency() {
        this.emergencyTriggered = false
      },
      updateSeenStatus(person, key) {
        let obj = {
          key: key,
          person: person,
          timeSeen: new Date()
        }
        let tempReport = {...this.emergencyReports[0]}
        let index = tempReport.userVisuallySeenKey.findIndex(x => x.person.name === person.name);
        if (index == -1) {
          tempReport.userVisuallySeenKey.push(obj)
        } else {
          tempReport.userVisuallySeenKey.splice(index, 1)
        }
        let ref = db.collection('emergencyReports').doc(this.emergencyReports[0].id)
        ref.set(tempReport)
      },
      hasUserBeenChecked(person) {
        let check = false
        if(this.emergencyActive) {

          for (var i = 0; i < this.emergencyReports[0].userVisuallySeenKey.length; i++) {
            if (this.emergencyReports[0].userVisuallySeenKey[i].person.name === person.name) {
              check = true
          }
        }
        }
        return check
      },
      closeEmergency() {
        // Open a dialog to confirm
        let report = {
          ...this.emergencyReports[0],
          end: {
            closedBy: this.name,
            endTime: new Date(),
            totalStaffActiveToday: this.totalStaffActiveToday,
            totalStaffStillOnsite: this.totalStaffStillOnsite,
            totalStaffSeen: this.totalStaffSeen
          }
        }
        report.emergencyActive = false
        let ref = db.collection('emergencyReports').doc(this.emergencyReports[0].id)
        ref.set(report).then(res => {
          this.emergencyTriggered = false
          this.emergencyActive = false
          this.emergencyText = 'Start emergency'
          this.closeEmergencyDialog = false
        })
      },
      // Firebase
      initFirebaseReport() {
        let report = {
          start: {
            initiatedBy: this.name,
            currnetStatusOfStaffAtStart: this.users,
            totalStaffActiveToday: this.totalStaffActiveToday,
            totalStaffStillOnsite: this.totalStaffStillOnsite
          },
          userVisuallySeenKey: [],
          emergencyActive: true,
          startTime: new Date(),
        }
        let reportID = `${report.startTime.getFullYear()}-${report.startTime.getMonth()}-${report.startTime.getDate()}`
        let ref = db.collection('emergencyReports').doc(reportID)
        ref.set(report)
      }
    },
    computed: {
      dataTable() {
        let data = []
        if (this.users !== null) {
          this.users.forEach(u => {
            if ('status' in u && u.firstName !== '') {
              
              const now = new Date()
              let obj = {
                name: `${u.firstName} ${u.lastName}`,
                time: u.updatedAt.toDate(),
                status: 'No activity'
              }
              if (u.updatedAt.toDate().getDate() === now.getDate()) {
                obj.status = u.status
              }
              if (this.filter.noActivity || this.filter.visuallySeen) {
                if (obj.status !== 'No activity' && !this.filter.visuallySeen && this.filter.noActivity) {
                  data.push(obj)
                }
                if (!this.hasUserBeenChecked(obj) && this.filter.visuallySeen) {
                  let index = data.findIndex(x => x.name === obj.name)
                  if (index === -1) {
                    if (obj.status !== 'No activity' && this.filter.noActivity) {
                      data.push(obj)
                    } else if (!this.filter.noActivity) {
                      data.push(obj)
                    }
  
                  }
                }
              } else {
                data.push(obj)
              }
  
  
            }
          })
        }
        return data
      },
      totalStaffActiveToday() {
        let count = []
        const now = new Date()
        if (this.dataReady) {
          count = this.dataTable.filter(u => u.time.getDate() === now.getDate())
        }
        return count.length
      },
      totalStaffStillOnsite() {
        const now = new Date()
        if (!this.dataReady) {
          return 0
        }
        return this.dataTable.filter((d) => {
          if (((d.status === 'Onsite, via Gate 3') || (d.status === 'Onsite, via Gate 2')) && (d.time.getDate() === now.getDate())) {
            return true
          }
        }).length
      },
      totalStaffSeen() {
        return this.emergencyReports[0].userVisuallySeenKey.length
      }
    },
    mounted() {
      this.$bind('users', db.collection('users').orderBy('firstName'))
        .then((doc) => {
          this.dataReady = true
        })
        .catch((error) => {
          console.log('error in loading: ', error)
        })
      // this.$bind('emergencyReports', db.collection('emergencyReports').where('emergencyActive', '==', true))
      //   .then((emergencyReports) => {
      //     console.log('Change')
      //     this.emergencyReports === emergencyReports
      //     this.reportDataReady = true
      //     if(emergencyReports.length > 0) {
      //       this.emergencyActive = true
      //     }
      //   })
      //   .catch((error) => {
      //     console.log('error in loading: ', error)
      //   })
      this.$bind('emergencyReports', db.collection('emergencyReports').where('emergencyActive', '==', true).onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          console.log(change.doc.data())
          this.emergencyReports.push({...change.doc.data(),
            id: change.doc.id
          })
        })
        console.log(this.emergencyReports)
        if(this.emergencyReports.length > 0) {
          this.emergencyActive = true
        }
        this.reportDataReady = true
      }))
        // .then((emergencyReports) => {
        //   console.log('Change')
        //   this.emergencyReports === emergencyReports
        //   this.reportDataReady = true
        //   if(emergencyReports.length > 0) {
        //     this.emergencyActive = true
        //   }
        // })
        // .catch((error) => {
        //   console.log('error in loading: ', error)
        // })
    },
    filters: {
      moment: (date) => {
        return moment(date).format('h:mm:ss a')
      },
      momentDay: (date) => {
        return moment(date).format('MMMM Do YYYY')
      }
    },
    created() {
      if(firebase.auth().currentUser){
        this.name = firebase.auth().currentUser.email
      }
    },
  }
</script>

<style>
  
</style>



// WEBPACK FOOTER //
// src/pages/Emergency.vue